// Launch telemetry: page views through Cloudflare Web Analytics (no cookies; only when the server has a token, /api/config
// `analytics`) and the browser's own errors, posted to /api/log so they show up in the server log.
import { api } from "./api.ts";

let reported = 0;
/** Posts an uncaught error (at most 5 per page view; the server limits per visitor too). */
function report(message: string, stack?: string) {
  if (++reported > 5) return;
  const body = JSON.stringify({ message: message.slice(0, 500), stack: stack?.slice(0, 2000), url: location.href.slice(0, 300) });
  if (!navigator.sendBeacon?.("/api/log", new Blob([body], { type: "application/json" }))) {
    void fetch("/api/log", { method: "POST", headers: { "content-type": "application/json" }, body, keepalive: true }).catch(() => {});
  }
}

export function startTelemetry() {
  window.addEventListener("error", (e) => report(e.message || "error", (e.error as Error | undefined)?.stack));
  window.addEventListener("unhandledrejection", (e) => {
    const r = e.reason as Error | undefined;
    report(`unhandled rejection: ${r?.message ?? String(e.reason)}`, r?.stack);
  });
  void api.config().then((cfg) => {
    if (!cfg.analytics) return;
    const s = document.createElement("script");
    s.defer = true;
    s.src = "https://static.cloudflareinsights.com/beacon.min.js";
    s.dataset.cfBeacon = JSON.stringify({ token: cfg.analytics, spa: true });
    document.head.append(s);
  }).catch(() => {});
}
